import React, { useState, useEffect } from 'react';
import moment from 'moment';
import useForm from 'react-hook-form';
import { Col, Container, Row } from 'reactstrap';
import { Session } from 'bc-react-session';
import { HashLinkContainer } from 'components';
import { ResourceProvider, GeoLocationProvider } from 'providers';

const session = Session.getSession();

const ResourceCapture = () => {
    const { register, handleSubmit, errors } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resourceNumber, setResourceNumber] = useState('');
    const [addAnother, setAddAnother] = useState(false);
    const [geoLocation, setGeoLocation] = useState(null);

    document.title = 'Capture Resource';

    useEffect(() => {
        const fecthData = async () => {
            const geoLocation = await GeoLocationProvider.getClientLocation();
            setGeoLocation(geoLocation);
        };
        let resourceNumber = '';
        resourceNumber  = session.payload.facility.subdistrict.district.province.iso_code;
        resourceNumber += session.payload.facility.subdistrict.district.code;
        resourceNumber += moment().format('YYMMDD');
        setResourceNumber(resourceNumber);
        fecthData();
    }, []);

    const onSubmit = data => {
        handleCaptureResource(data);
    };

    async function handleCaptureResource(data) {
        setIsSubmitting(true);
        const post = data;
        post.facility_id = session.payload.facility.id;
        post.metadata = {
            resource_reference: resourceNumber,
            facility: session.payload.facility,
            date: moment().format('MMMM DD, YYYY hh:mm:ss a'),
            geo_location: geoLocation,
        };
        const result = await ResourceProvider.add(post);
        if (result.success) {
            alert('Resource successfully added!');
            if (addAnother) {
                window.location = '/cpanel/resources/capture';
            } else {
                window.location = '/cpanel/dashboard';
            }
        } else {
            alert(result.message);
        }
        setIsSubmitting(false);
    }

    const handlePrint = () => {
        window.print();
    };

    const toggleAddAnother = (e) => {
        setAddAnother(e.currentTarget.checked);
    };

    return (
        <Container fluid className="pd-x-0 pd-lg-x-10 pd-xl-x-0">
            <ol className="breadcrumb df-breadcrumbs mg-b-10" style={{ padding: 0, backgroundColor: 'transparent' }}>
                <li className="breadcrumb-item">
                    <HashLinkContainer to="/cpanel/dashboard">
                        <a href="/cpanel/dashboard">Dashboard</a>
                    </HashLinkContainer>
                </li>
                <li className="breadcrumb-item">Resources</li>
                <li className="breadcrumb-item active" aria-current="page">Capture</li>
            </ol>
            <div className="d-sm-flex align-items-center justify-content-between">
                <div>
                    <h4 className="mg-b-10 mg-t-30">Resource #{resourceNumber}</h4>
                    <p className="mg-b-30 tx-color-03">Captured on {moment().format('MMMM DD, YYYY')}</p>
                </div>
                <div className="mg-t-20 mg-sm-t-0">
                    <button
                        type="button"
                        className="btn btn-white"
                        onClick={handlePrint}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-printer mg-r-5"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg> Print
                    </button>
                    {/* <button className="btn btn-white mg-l-5"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail mg-r-5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg> Email</button> */}
                </div>
            </div>
            <div className="tx-13 mg-b-25">
                <form method="post" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                    <div className="wizard clearfix">
                        <div className="content clearfix" style={{ borderTop: 'none' }}>
                            <Row>
                                <Col sm={6} lg={8}>
                                    <label className="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Captured By</label>
                                    <h6 className="tx-15 mg-b-0">
                                        {session.payload.user.first_name} {session.payload.user.last_name}
                                    </h6>
                                    <p className="mg-b-10">{session.payload.user.user_role.description}</p>

                                    <p className="mg-b-0">{session.payload.facility.name}</p>
                                    <p className="mg-b-0">Tel No: {session.payload.user.mobile}</p>
                                    <p className="mg-b-0">Email: {session.payload.user.email}</p>
                                </Col>
                                <Col sm={6} lg={4}>
                                    <label className="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Resource Information</label>
                                    <ul className="list-unstyled lh-7">
                                        <li className="d-flex justify-content-between">
                                            <span>Resource #</span>
                                            <span>{resourceNumber}</span>
                                        </li>
                                        <li className="d-flex justify-content-between">
                                            <span>Province</span>
                                            <span>{session.payload.facility.subdistrict.district.province.name}</span>
                                        </li>
                                        <li className="d-flex justify-content-between">
                                            <span>District Code</span>
                                            <span>{session.payload.facility.subdistrict.district.code}</span>
                                        </li>
                                        <li className="d-flex justify-content-between">
                                            <span>Capture on</span>
                                            <span>{moment().format('MMMM DD, YYYY')}</span>
                                        </li>
                                        <li className="d-flex justify-content-between">
                                            <span>Time</span>
                                            <span>{moment().format('hh:mm a')}</span>
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                            <hr className="mg-y-30" />
                            <h3 tabIndex="-1" className="title current">Resource Information</h3>
                            <p>Please enter resource information below and save!</p>
                            <Row className="row-sm">
                                <Col sm={4} className={`form-group ${errors.name && 'is-invalid'} mg-t-10 mg-sm-t-0`}>
                                    <label>Name</label>
                                    <input type="text" name="name" className="form-control" placeholder="Resource name" ref={register({ required: true })} />
                                </Col>
                                <Col sm={8} className={`form-group ${errors.description && 'is-invalid'} mg-t-10 mg-sm-t-0`}>
                                    <label>Description</label>
                                    <input type="text" name="description" className="form-control" placeholder="Resource description" ref={register({ required: true })} />
                                </Col>
                                <Col sm={4} className={`form-group ${errors.mean && 'is-invalid'} mg-t-10 mg-sm-t-0`}>
                                    <label>Mean</label>
                                    <input type="number" name="mean" className="form-control" ref={register({ required: true })} />
                                </Col>
                                <Col sm={4} className={`form-group ${errors.lower && 'is-invalid'} mg-t-10 mg-sm-t-0`}>
                                    <label>Lower</label>
                                    <input type="number" name="lower" className="form-control" ref={register({ required: false })} />
                                </Col>
                                <Col sm={4} className={`form-group ${errors.upper && 'is-invalid'} mg-t-10 mg-sm-t-0`}>
                                    <label>Upper</label>
                                    <input type="number" name="upper" className="form-control" ref={register({ required: false })} />
                                </Col>
                            </Row>
                        </div>
                        <div className="actions clearfix">
                            <div className="text-right">
                                <div className="d-flex">
                                    <div>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={isSubmitting}
                                        >
                                            &nbsp;
                                            Save Resource
                                            &nbsp;
                                    </button>
                                    </div>
                                    <div className="mg-l-20">
                                        <div className="custom-control custom-switch mg-b-10 mg-t-10">
                                            <input type="checkbox" className="custom-control-input" id="addAnother" onChange={toggleAddAnother} />
                                            <label className="custom-control-label" htmlFor="addAnother">Add Another</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Container>
    );
};

export default ResourceCapture;
